import { render, staticRenderFns } from "./static.vue?vue&type=template&id=065e0222&"
import script from "./static.vue?vue&type=script&lang=js&"
export * from "./static.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports